import { render, staticRenderFns } from "./RecordExtraLiftsDialog.vue?vue&type=template&id=193ce830&"
import script from "./RecordExtraLiftsDialog.vue?vue&type=script&lang=js&"
export * from "./RecordExtraLiftsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecordExtraLiftsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports